import React from 'react';

import { SpecSection } from 'Components/SpecSection';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';

import { MECHANICAL_AND_ELECTRICAL_ISSUES_FIELDS } from './MechanicalAndElectricalIssuesSection.const';

export const MechanicalAndElectricalIssuesSection: React.FC = () => {
	const { electricalAndMechanicalIssues } = useVehicleData();

	return <SpecSection data={electricalAndMechanicalIssues} fields={MECHANICAL_AND_ELECTRICAL_ISSUES_FIELDS} />;
};
